export default "__VITE_ASSET__IMkqfgNT__"